// 足裏を床に残す比較版 (DEV ?soleLock=1・2026-10-19・docs/research/2026-10-19-boss-polish-vs-popular-games.md §5)。
//   配布版はタイムラインの offset.y で「絵ごと」上下させるので、沈み込み・伸び上がりのたびに靴底も床から
//   浮く／床へめり込む (ラボ実測: 介錯 overhead_raise −8〜−12px・aim_hold +14px・覚醒王 bite_windup_deep +7〜9px。
//   基準の騎士・獣は ±1.3px 以内)。
//   比較版は offset.y を「足元ピボットの縦の伸び縮み」へ置き換える = 頭の上下量はほぼ同じ・靴底は床のまま。
//   跳ぶ絵 (宙にいる絵) は置き換えない。横の offset・回転・当たり・影は一切触らない。描画専用。
//   ⚠️ 既定は切 (URL 指定なし＝配布版のまま)。採否は作者の見比べで決める。

/** 宙にいる絵 = 体ごと持ち上がるのが正しいので置き換えない。 */
const AIRBORNE_IMAGE = /leap|air|launch|hop|jump|pounce|wall_kick|fly/
/** これより大きい上下は跳躍・壁張り付き (例 覚醒王 dash_form −58) とみなして置き換えない。 */
const JUMP_OFFSET_PX = 30

let soleLockOn: boolean | null = null

export function bossSoleLockEnabled(): boolean {
  if (soleLockOn === null) {
    soleLockOn = import.meta.env.DEV && typeof location !== 'undefined'
      && new URLSearchParams(location.search).get('soleLock') === '1'
  }
  return soleLockOn
}

/** テスト用。 */
export function setBossSoleLockForTest(on: boolean | null): void {
  soleLockOn = on
}

/**
 * offset.y (下が正) を足元ピボットの scale.y へ換算する。
 *   頭の移動量 = −offsetY を保つ: 高さ H の絵を足元で (1 − offsetY/H) 倍すると頭が −offsetY 動く。
 *   縮みすぎ・伸びすぎで絵が壊れないよう倍率の変化は ±15% で止め、止めた分だけ offset に残す。
 */
export function soleLockMotion(
  offsetY: number, scaleY: number, displayHeight: number, image: string | null,
): { offsetY: number, scaleY: number } {
  if (offsetY === 0 || Math.abs(offsetY) > JUMP_OFFSET_PX || displayHeight <= 0 || (image !== null && AIRBORNE_IMAGE.test(image))) {
    return { offsetY, scaleY }
  }
  const want = -offsetY / displayHeight
  const k = Math.max(-0.15, Math.min(0.15, want))
  const rest = (want - k) * -displayHeight
  return { offsetY: rest, scaleY: scaleY * (1 + k) }
}
